// JOBE-0044.4: LibraryGrid — three-column CSS grid (260 / 1fr / 360 at
// 1480 design width; flexible via minmax so smaller viewports
// compress). Slots: rail (JOBE-0044.6), list (this subtask), inspector
// (JOBE-0044.13).

export function LibraryGrid({ rail, list, inspector }) {
  const cls = rail ? 'library-grid' : 'library-grid library-grid--no-rail';
  return (
    <div className={cls}>
      {rail && (
        <aside className="library-rail" aria-label="Library navigation rail">
          {rail}
        </aside>
      )}
      <main className="library-list">
        {list}
      </main>
      <aside className="library-inspector" aria-label="Inspector">
        {inspector}
      </aside>
    </div>
  );
}
